import React, { FC, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { post } from 'src/apis/apiService'
import { ON_DEMAND_APIS } from '../../../apis/onDemandApi'
import { StarRating } from '../../StarRating'
import { AbstractRatingDiv } from './styled'

interface AbstractRatingProps {
  abstractId: number
  defaultRated: boolean
}

export const AbstractRating: FC<AbstractRatingProps> = ({ abstractId, defaultRated }) => {
  const [rated, setRated] = useState(defaultRated)

  useEffect(() => {
    setRated(defaultRated)
  }, [defaultRated])

  const rateAbstract = (rating) => {
    post(
      ON_DEMAND_APIS.RATE_ABSTRACT(abstractId),
      (result) => {
        toast(`Rated this abstract ${rating} stars!`)
        setRated(result.success)
      },
      (error) => {
        console.error(error)
      },
      {
        rating,
      }
    )
  }

  return (
    <AbstractRatingDiv>
      {rated ? <p className="ratedText">Thank you for rating this abstract!</p> : <StarRating handleSubmit={rateAbstract} title="Rate this Abstract" />}
    </AbstractRatingDiv>
  )
}
